import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';

interface CourierOption {
  id: string;
  name: string;
}

export const useCouriers = () => {
  const httpClient = createHttpClient(apiClientWH);

  return useQuery<CourierOption[]>({
    queryKey: ['couriers'],
    queryFn: async () => {
      const raw = await httpClient.get<any>('/couriers');
      const list = Array.isArray(raw) ? raw : (raw.data ?? []);
      return list.map((c: any) => ({
        id: String(c.id),
        name: c.name,
      }));
    },
    staleTime: 5 * 60 * 1000,
  });
};
